import { render, staticRenderFns } from "./JobOfferWid.vue?vue&type=template&id=a5acde2c&scoped=true&"
import script from "./jobOfferWid.js?vue&type=script&lang=js&"
export * from "./jobOfferWid.js?vue&type=script&lang=js&"
import style0 from "./JobOfferWid.vue?vue&type=style&index=0&id=a5acde2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5acde2c",
  null
  
)

export default component.exports